<!-- =========================================================================================
  File Name: Category.vue
  Description: Category Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="mb-2" v-if="loaded">

      <div slot="no-body" class="tabs-container pl-6 py-3">
        <div class="w-full vx-row mb-2">
          <div class="vx-col w-3/12">
            <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :enabled="editing" v-model="data_local.name"/>
          </div>
          <div class="flex vx-col w-9/12 items-center justify-end h-full">
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="save" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-save" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Guardar cambios</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm border border-solid border-warning cursor-pointer" @click="reset_data" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-corner-up-left" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Cancelar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="editing = true" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-edit-2" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Editar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-danger text-white cursor-pointer" @click="confirmDeleteRecord" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-x" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Eliminar</div>
            </div>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-1/3">
            <ejs-numerictextbox floatLabelType="Auto" placeholder="Secuencia" format="N0" :enabled="editing" textAlign='Right' v-model="data_local.sequence"/>
          </div>
          <div class="vx-col w-2/3">
            <ejs-dropdownlist floatLabelType="Auto" placeholder="Categoría superior" highlight=true :dataSource="categories" :fields="{text: 'name', value: 'id'}" v-model="data_local.parentId" :enabled="editing"></ejs-dropdownlist>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-full">
            <ejs-multiselect
              ref="subCategories"
              floatLabelType="Auto"
              placeholder="Subcategorías"
              :dataSource="categories"
              mode="Box"
              :fields="{text: 'name', value: 'id'}"
              v-model="data_local.subCategories"
              :enabled="editing"
            ></ejs-multiselect>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-1/3 my-3">
            <ejs-checkbox label='Mostrar en página de incio' v-model="data_local.showcase" :checked="data_local.showcase" :disabled="!editing"></ejs-checkbox>
          </div>
        </div>
        <div class="w-full flex flex-col mt-4 p-2" v-if="data_local.showcase">
          <h5>Imagen: {{ data_local.imageURL }}</h5>
          <div
            class="flex w-1/4 my-4 block bg-contain bg-no-repeat bg-center items-end justify-between border border-dotted border-primary"
            :style="{ 'background-image': `url(${previewImage})`}"
            style="height: 400px; background-repeat: no-repeat; background-position: center center;"
          >
            <input
              ref="fileInput"
              type="file"
              accept="image/*"
              @input="pickFile"
              class="opacity-0 absolute"
            />
            <vs-button class="ml-2 mb-2" color="success" icon-pack="feather" icon="icon-image" @click="selectImage" v-if="editing">Seleccionar</vs-button>
            <vs-button class="mr-2 mb-2" color="danger" icon-pack="feather" icon="icon-x" @click="previewImage = null" v-if="editing">Eliminar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
  import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
  import {DropDownListPlugin, MultiSelectPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {firebase, db, storage} from '@/firebaseConfig';

  Vue.use(TextBoxPlugin);
  Vue.use(NumericTextBoxPlugin);
  Vue.use(CheckBoxPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(MultiSelectPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        data: null,
        data_local: {
          id: '',
          code: '',
          name: '',
          parentId: '',
          subCategories: '',
          subCategoryList: [],
          sequence: 0,
          showcase: false,
          imageURL: ''
        },
        id_not_found: false,
        currentStatus: 0,
        uploadFieldName: 'photos',
        previewImage: null
      }
    },
    computed: {
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      categories() {
        return this.$store.getters.categoriesList;
      },
      image() {
        let image = '';
        if (this.data_local.imageURL) {
          image = [this.imagesURL, '/showcase%2F', this.data_local.imageURL.split('.')[0], '@400.', this.data_local.imageURL.split('.')[1], '?alt=media'].join('');
        }
        return image;
      }
    },
    methods: {
      reset_data() {
        if (this.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.data_local.subCategoryList = this.data.subCategories.split(',');
          this.previewImage = this.image;
          this.editing = false;
          this.loaded = true;
        } else {
          this.$router.push({name: 'categories'});
        }
      },
      selectImage() {
        this.$refs.fileInput.click();
      },
      pickFile() {
        const input = this.$refs.fileInput;
        const file = input.files;
        if (file && file[0]) {
          const reader = new FileReader;
          reader.onload = e => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(file[0]);
          this.$emit('input', file[0]);
        }
      },
      getData(id) {
        if (id) {
          if (id == '0') {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            this.data = this.$store.getters.getCategory(id);
            this.reset_data();
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        let message = '';
        if (this.data_local.name.trim() == '') {
          message = 'Debe indicar una descripción';
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error validando información',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      updateImage(imageFile, newId) {
        const self = this;
        const fileParts = imageFile.name.split('.');
        let extension = '.';
        if (fileParts.length > 1) {
          extension = `.${fileParts[1]}`;
        }
        const imageRef = storage.ref().child(`products/${newId}${extension}`);
        imageRef.put(imageFile)
          .then(() => {
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Datos de la categoría fueron actualizados correctamente',
              color: 'primary'
            });
            if (self.id == 0) {
              self.$router.push({name: 'category', params: {id: newId}});
            }
            self.editing = false;
          })
          .catch((error) => {
            self.$vs.notify({
              title: 'ADVERTENCIA',
              text: `Datos de la categoría fueron actualizados correctamente pero ocurrió un error al actualizar imagen: ${error.message}`,
              color: 'warning'
            });
          });
        self.$vs.loading.close();
      },
      updateList(list, newId) {
        const self = this;
        db.collection('catalogs').doc('categories').update({list: list})
          .then(() => {
            if (self.$refs.fileInput && self.$refs.fileInput.files.length > 0) {
              self.updateImage(self.$refs.fileInput.files[0], newId);
            } else {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de la categoría fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == '0') {
                self.$router.push({name: 'category', params: {id: newId}});
              }
              self.editing = false;
              self.$vs.loading.close();
            }
          })
          .catch((error) => {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: error.message,
              color: 'danger'
            });
            self.$vs.loading.close();
          })
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de categoría',
            type: 'point'
          });
          if (this.data_local.showcase) {
            if (this.$refs.fileInput) {
              if (this.$refs.fileInput.files.length > 0) {
                this.data_local.imageURL = this.$refs.fileInput.files[0].name;
              }
            }
          } else {
            this.data_local.imageURL = '';
          }
          const list = [...this.$store.getters.categoriesList];
          if (this.data_local.id > 0) {
            const index = list.findIndex(i => i.id === this.data_local.id);
            if (index >= 0) {
              list[index] = JSON.parse(JSON.stringify(this.data_local));
              list[index].subCategories = list[index].subCategoryList.join(',');
              delete list[index].subCategoryList;
              this.updateList(list, this.data_local.id);
            }
          } else {
            const self = this;
            db.collection('catalogs').doc('categories').update({sequence: firebase.firestore.FieldValue.increment(1)})
              .then(() => {
                const data = {...this.data_local};
                db.collection('catalogs').doc('categories').get()
                  .then(doc => {
                    if (doc.exists) {
                      const newId = doc.data();
                      data.id = newId.sequence.toString();
                      data.subCategories = data.subCategoryList.join(',');
                      delete data.subCategoryList;
                      list.push(data);
                      self.updateList(list, data.id);
                    }
                  })
                  .catch((error) => {
                    self.$vs.notify({
                      title: 'Error al obtener secuencia',
                      text: error.message,
                      color: 'danger'
                    });
                    self.$vs.loading.close();
                  });
              })
              .catch((error) => {
                self.$vs.notify({
                  title: 'Error al actualizar',
                  text: error.message,
                  color: 'danger'
                });
                self.$vs.loading.close();
              });
          }
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar categoría "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando categoría',
          type: 'point'
        });
      }
    },

    mounted() {
      this.id = this.$route.params.id;
      const self = this;
      setTimeout(function () {
        self.getData(self.id);
      }, 750);
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
